import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

const styles = {
  imageUploadSection: {
    mt: 2,
    mb: 2,
    p: 1,
    textAlign: 'center',
    width: '100%',
    boxSizing: 'border-box'
  },
  uploadButton: {
    width: '100%',
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 1,
    '&:hover': {
      bgcolor: 'action.hover'
    }
  },
};

const ImageInput = ({ setSelectedImages }) => {
  const fileInputRef = useRef(null);

  const handleImageSelect = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map(file => ({
      file,
      preview: URL.createObjectURL(file),
      isExisting: false, 
      url: null 
    }));

    setSelectedImages(prev => [...prev, ...newImages]);
  };

  return (
    <Box sx={styles.imageUploadSection}>
      <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleImageSelect}
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
      <Box
        sx={styles.uploadButton}
        onClick={() => fileInputRef.current.click()}
      >
        <AddPhotoAlternateIcon sx={{ fontSize: 40, mb: 1 }} />
        <Typography>
          Click to add photos
        </Typography>
      </Box>
    </Box>
  );
};

export default ImageInput; 